import { getFilterableCategories } from "selectors/factors"
import createModule from "../createModule"
import view from "./view"
import { getSelectedCategory } from "./selectors"
import { Creators } from "./model"
import { getSelectedModelId } from "modules/portfolio-root/selectors/portfolios"
import { MODEL_METADATA_QUERY } from "resources/models"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    modelId: getSelectedModelId(state),
  }),
  required: ["account", "modelId"],
  data: [
    MODEL_METADATA_QUERY,
  ],
  mapStateToProps: state => ({
    categories: getFilterableCategories(state),
    category: getSelectedCategory(state),
  }),
  actions: {
    ...Creators,
  },
})
